import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams, useHistory } from "react-router-dom";

import StateList from "../../components/State/StateList";
import StateFormModal from "../../components/State/StateFormModal";
import ListPagination from "../../components/Common/ListPagination";
import * as StateActions from "../../store/actions/State";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getPath } from "../../utils";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import FilterButton from "../../components/Common/FilterButton";

const States = (props) => {
  const params = useParams();
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.STATE];

  const filterFields = ["country_id", "name"];
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const handleClick = (type, id) => {
    setModalState(type);
    setActiveId(id);
  };

  const handleClose = () => {
    setModalState(false);
    setActiveId("");
    props.resetStateState({ state: "activeState" });
    if (
      history.location.pathname !== "/states" &&
      getPath(props.stateList, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/states");
    } else if (
      history.location.pathname !== "/states" &&
      getPath(props.stateList, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/states");
    }
  };

  // handle pagination
  const handleNavClick = (action) => {
    const pageRequest = { page: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    props.getStateList(props.activeFilters, pageRequest);
  };

  const getModal = () => {
    const defaultProps = {
      activeId: activeId,
      modalState: modalState,
      handleClose: handleClose,
      countryList: props.countryList,
    };

    switch (modalState) {
      case "Add":
      case "Edit":
        return <StateFormModal {...defaultProps} />;
      case "Filter":
        return <StateFormModal {...defaultProps} filterFields={filterFields} />;
      default:
        return;
    }
  };

  useEffect(() => {
    if (shouldRenderList === true) {
      props.getStateList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="State-View container">
      <FlexContainer align="flex-start">
        <Heading>States</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="StatesAddBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <StateList stateList={props.stateList} />
      <Permission requiredPerms={[allActions.LIST]}>
        <ListPagination
          nextPage={props.nextPage}
          prevPage={props.prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { State } = state;
  return {
    stateList: State.stateList,
    nextPage: State.nextPage,
    prevPage: State.prevPage,
    activeFilters: State.activeFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStateList: bindActionCreators(StateActions.getStateList, dispatch),
    resetStateState: bindActionCreators(StateActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(States);
